export const BACKGROUND_TYPES = {
  IMAGE: 'image',
  VIDEO: 'video',
};

export const OVERLAY_POSITIONS = {
  CENTER: 'Center',
  BOTTOM_LEFT: 'Bottom-Left',
  BOTTOM_RIGHT: 'Bottom-Right',
  PANEL: 'Panel',
};

export const PAGE_SECTIONS = {
  CTA_IMAGES: 'pageSectionCtaImages',
  IMAGE: 'pageSectionImage',
  CARD_CAROUSEL: 'pageSectionCardCarousel',
  SHOWCASE: 'pageSectionShowcase',
  IMAGE_COPY: 'pageSectionImageCopy',
  EMAIL_MODULE: 'pageSectionEmailSignupModule',
  SECONDARY_NAVIGATION: 'pageSectionSecondaryNavigation',
  TESTIMONIAL_CAROUSEL: 'pageSectionTestimonialCarousel',
  ASSET_DECORATED_CAROUSEL: 'pageSectionAssetDecoratedCarousel',
  FEATURED_SLIDESHOW: 'pageSectionFeaturedSlideshow',
};

export const HERO_TYPES = {
  SECONDARY_PROMO_HERO: 'pageSectionSecondaryPromoHero',
  PRIMARY_HERO: 'pageSectionHeroV2',
  PRIMARY_HERO_V3: 'pageSectionHeroV3',
};

export const PAGE_SECTION_APPEARANCES = {
  TESTIMONIAL: 'Testimonial',
  SLIDE_SHOW: 'Slide Show',
};

export const VIDEO_ASPECT_RATIO = 1920 / 1080;
